import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { get_mid_banners } from '../store/reducers/homeReducer';
import Container from './Container';

const MidBanner = () => {
  const dispatch = useDispatch();
  const { mid_banners } = useSelector((state) => state.home);

  useEffect(() => {
    dispatch(get_mid_banners());
  }, [dispatch]);

  if (!mid_banners || mid_banners.length === 0) return null;

  return (
    <Container className="my-6 flex flex-col gap-3">
      {mid_banners.map((b) =>
        b.link ? (
          <Link key={b._id} to={b.link}>
            <img
              src={b.banner}
              alt="Banner"
              className="w-full h-16 md:h-20 object-cover rounded-lg shadow"
            />
          </Link>
        ) : (
          <img
            key={b._id}
            src={b.banner}
            alt="Banner"
            className="w-full h-16 md:h-20 object-cover rounded-lg shadow"
          />
        )
      )}
    </Container>
  );
};

export default MidBanner;
